export const EMPLOYER_MATCH_OPTIONS = {
  NOT_SURE: 0,
  NO_MATCH: 1,
  MATCH_50: 2,
  MATCH_100: 3,
  OTHER_MATCH: 4,
  SAFE_HARBOR_1: 5,
  SAFE_HARBOR_2: 6,
  PERCENT_COMPENSATION: 7,
  MULTI_TIER: 9,
};

export const EMPLOYER_LIMIT_OPTIONS = {
  NO_LIMIT: 0,
  UP_3: 1,
  UP_6: 2,
  OTHER: 3,
};

export const DEFAULT_TIER = { Limit: null, Match: null };
export const DEFAULT_ADDITIONAL_TIER = { Limit: '0', Match: '0' };
export const DEFAULT_NON_ELECTIVE_CONTRIBUTION = '0';
